export default {
    CALCULATE_HASH: 'calculate hash',
    SEARCH_HASH: 'search hash',
    FOUND_HASH: 'found hash',
    UPLOAD: 'upload',
    UPLOAD_COMPLETE: 'upload complete'
};
